import React, { useContext } from "react";
import MedalImage from "../../Assets/AccomplishmentsPage/best.svg";
import { AppPreferencesContext } from "../../../General/AppPreferencesProvider";
import { AppPreferencesContextType } from "../../../types/AppPreferencesProvider";
import useAddRef, { UseAddRefOptions } from "../useAddRef";
import { useIcon } from "@SeemplicityDev/shared";

interface AccomplishmentsPageProps extends UseAddRefOptions {
  data?: {
    customer_name: string;
    title: string;
    description: string;
  };
}

const AccomplishmentsPage: React.FC<AccomplishmentsPageProps> = ({
  data,
  addRef,
  index,
}) => {
  const ref = useAddRef({ addRef });
  const {
    appPreferences: { useAI },
  } = useContext(AppPreferencesContext) as AppPreferencesContextType;
  const { getSvg } = useIcon("LIGHT");
  return (
    <div className={`eoy-page accomplishments-page`} ref={ref}>
      <h3 className="title-container">
        {useAI && <img src={getSvg("icon-ai")} alt="AI" className="ai-star" />}
        Accomplishments 2025{" "}
        {useAI && (
          <span className="ai-text">(generated by Seemplicity AI)</span>
        )}
      </h3>
      <div className="content-container">
        <div className="text-container">
          <h4>
            <span className="sub">{data?.title}</span>
          </h4>
          <p className="accomplishments-description">{data?.description}</p>
        </div>
        <div className="image-container">
          <img src={MedalImage} alt="Medal" className="medal-image" />
        </div>
      </div>
    </div>
  );
};

export default AccomplishmentsPage;
